var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ModalForm',{attrs:{"action":"feedback/send","form-config":_vm.props.formInfo,"submit-label":_vm.props.button},on:{"submit:success":_vm.onSuccessSubmit,"submit:error":_vm.onErrorSubmit},scopedSlots:_vm._u([{key:"personalDataAgreement",fn:function(ref){
var field = ref.field;
var input = ref.input;
return [_c('FormField',{attrs:{"field":field}},[_c('PersonalDataAgreement',{attrs:{"value":field.value,"error":field.error},on:{"input":input,"link-click":_vm.onLinkClick}})],1)]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/templates/components/base/modals/collab.vue?vue&type=template&id=7ccfc7a0&
// module id = 1637
// module chunks = 0